import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import {formatCopFull} from '@/lib/money'
import type {PlanPrice} from '@/hooks/inci/cartera/use-billing'

/** Decisión comercial pendiente: por ahora no se muestra el precio de lista. El `: boolean`
 * explícito evita que TypeScript lo estreche a `false` y deje muerto el otro camino. */
const SHOW_LIST_PRICE: boolean = false

/** Siempre que el precio no venga de la lista base, para que la diferencia no parezca un error. */
export function PrecioAcordadoTag({price}: {price: PlanPrice | null | undefined}) {
  const {t} = useTranslation()
  if (!price || price.origen !== 'acordado') return null
  return (
    <span className="inline-flex items-center gap-2" data-testid="billing-precio-acordado">
      <Tag tone="neutral">{t('planFacturacion.precioAcordado.tag')}</Tag>
      {SHOW_LIST_PRICE && price.list_amount_cop != null && (
        <span className="font-mono text-xs text-muted-foreground line-through tabular-nums">
          {formatCopFull(price.list_amount_cop)}
        </span>
      )}
    </span>
  )
}
